import { ProjectService } from './project.service';
import {
    Component,
    EventEmitter,
    Injector,
    Output,
    ViewChild,
    OnInit,
    Input,
  } from '@angular/core';
  import { AppComponentBase } from '@shared/common/app-component-base';
  import { ModalDirective } from 'ngx-bootstrap/modal';
  
  @Component({
    selector: 'myProjectSelectionModal',
    templateUrl: './my-projects-selection-model.component.html',
    styleUrls: ['./my-projects-selection-model.component.less'],
  })
  export class MyProjectSelectionModalComponent
    extends AppComponentBase
    implements OnInit {
    @ViewChild('myProjectSelectionModal', { static: true }) modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    @Input() showProjectPopup: Boolean;
    @Input() initialProjectPopup: Boolean;

    public saving = false;
    
    myProjects;
    
    constructor(
      injector: Injector,
      private _projectService: ProjectService
    ) {
      super(injector);
    }
  
    ngOnInit(): void {
     
    }
  
    show(): void {
      if(!this.myProjects){
        this._projectService.getMyProjects()
        .then((result) => {
          this.myProjects = result.items;
          this.modal.show();
        });
      }
    }
    async setCurrentProject(project: any){
      await this._projectService.setCurrentProjectAsync(project);
      (window as any).location.href = '/app/main/dashboard';
    }
    close(): void {
        this.modal.hide();
    }
  }
  